import * as React from 'react';
import { Button, Modal, UIHeading2, useDeviceType } from '@cian/ui-kit';

import { TRoundButtonTheme } from '@cian/ui-kit/button/types';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './SuccessModalWindow.css';
import { useResponsiveText } from '../../ResultModalWindow';

export interface ISuccessModalWindowProps {
  onClose: () => void;
  open: boolean;
}

export const SuccessModalWindow: React.FC<ISuccessModalWindowProps> = ({ onClose, open }) => {
  const UIText = useResponsiveText();
  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  return (
    <Modal
      size="S"
      closeButtonProps={{ theme: 'fill_light' as TRoundButtonTheme, title: 'Закрыть', icon: <IconActionClose12 /> }}
      open={open}
      body={
        <div className={styles['body']}>
          <div className={styles['image']} />
          <div className={styles['title']}>
            <UIHeading2 textAlign="center">Начали искать, скоро перезвоним</UIHeading2>
          </div>
          <div className={styles['description']}>
            <UIText>
              Консультант перезвонит в течение пары часов, задаст уточняющие вопросы и предложит
              подходящие&nbsp;варианты
            </UIText>
          </div>
        </div>
      }
      footer={
        <div className={styles['button-wrapper']} data-testid="ThanksButton">
          <Button onClick={onClose} fullWidth={isPhone}>
            Спасибо, жду
          </Button>
        </div>
      }
      data-testid="SuccessModalWindowContent"
      onOpenChange={onClose}
    />
  );
};
